module.exports = __webpack_public_path__ + "static/media/bmresume.a27768b4.pdf";